import { Navigate } from "react-router-dom";
import { useModuleSettings } from "@/hooks/useModuleSettings";

interface LandingModuleGuardProps {
  moduleKey: string;
  children: React.ReactNode;
}

export default function LandingModuleGuard({ moduleKey, children }: LandingModuleGuardProps) {
  const { isModuleEnabled, isLoading } = useModuleSettings();

  if (isLoading) return <>{children}</>;
  if (!isModuleEnabled(moduleKey)) return <Navigate to="/" replace />;

  return <>{children}</>;
}
